// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V10H2V2ZM8 4.99805H5.99609V7.00195H7.99609V6.99805H8V4.99805ZM18 4.99805H10V6.99805H18V4.99805Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 12H22V22H2V12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-menu-filled')
export default class MenuFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'menu-filled',
    }
  }
}
